import { createFileRoute } from "@tanstack/react-router";
import { browseDogsFeedRoute } from "@/app-clients/browse-dogs";

export const Route = createFileRoute("/feed")({
    beforeLoad: browseDogsFeedRoute.beforeLoad,
});
